import Vue from "vue"
import App from "./App.vue"
import vuetify from "./plugins/vuetify"
import "roboto-fontface/css/roboto/roboto-fontface.css"
import "@mdi/font/css/materialdesignicons.css"
import "./assets/styles/style.scss"
import * as VeeValidate from "vee-validate"
import {ValidationObserver, ValidationProvider, extend} from "vee-validate"
import * as rules from "vee-validate/dist/rules"
import VueMask from "v-mask"
Vue.use(VueMask)

Vue.component("ValidationObserver", ValidationObserver),
	Vue.component("ValidationProvider", ValidationProvider)

Object.keys(rules).forEach((rule) => {
	extend(rule, rules[rule])
})
Vue.use(VeeValidate)
Vue.config.productionTip = false

new Vue({
	vuetify,
	render: (h) => h(App),
}).$mount("#app")
